<template>
    <v-container v-if="(uid!==undefined && this.opened)">
      <v-alert border="left" :type="type" value="true" v-if="type">
            {{alert}}
        </v-alert>
      <v-card color="#e6ecff" shaped>
        <v-row color="red">
          <v-col>
            <p class="text-right">Seu Link:</p>
          </v-col>
          <v-col>
            <p class="text-right;text-top">
                <a :href="this.geturl()">
                    <span id="urlToCopy">{{this.geturl()}}</span>
                </a>
            </p>
          </v-col>
          <v-col><v-btn
          right
          @click="copyText"
          color="blue"
          >Copiar</v-btn></v-col>
        <v-col class="text-right">
          <v-icon @click="closeMe()">mdi-close</v-icon>
        </v-col>
        </v-row>
        </v-card>
    </v-container>
</template>
<script>
export default {
  name: 'Link',
  props: ['uid'],
  data() {
    return {
      url: `${window.location.origin}/movies/`,
      alert: '',
      type: null,
      elapse: null,
      opened: true,
    };
  },
  mounted() {
  },
  methods: {
    geturl() {
      return `${this.url}${this.uid}`;
    },
    copyText() {
      const copyText = document.getElementById('urlToCopy');
      const textArea = document.createElement('textarea');
      textArea.value = copyText.textContent;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('Copy');
      textArea.remove();
      this.showAlert('info', 'URL Copiada!');
    },
    closeMe() {
      this.opened = false;
    },
    showAlert(type, message) {
      this.type = type;
      this.alert = message;
      // eslint-disable-next-line
      const timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 3000);
      this.elapse = 1;
      // eslint-disable-next-line
      const t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }
      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse += 1;
        }
      }, 1000);
    },
  },
};
</script>
